import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import axios from "axios";

import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
import api from "../../../../API";
import MemberDetailDiaglog from  "./MemberDetailDialog";
import { useSelector } from "react-redux";
// import { getCodeNm } from "../../component/common/CodeNm";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatephone(phone: string) {
  const re = /^\(?(\d{3})\)?[- ]?(\d{4})[- ]?(\d{4})$/;
  return re.test(String(phone).toLowerCase());
}

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>중간관리자 연결</Box>
        <Select
          labelId="demo-simple-select-label"
          id="role" 
          name="role"
          value={props.managerParam}
          label="중간관리자 연결"
          sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
          onChange={(e)=>props.setManagerParam(e.target.value)}
        >
          <MenuItem dense value={"연결안됨"}>연결안됨</MenuItem>
          {props.managers.length !== 0 ? (
            props.managers.map((manager: any, index:number) => {
              return (
                <MenuItem key={manager.email} dense value={manager.email}>{manager.name}</MenuItem>
              );
            })
          ) : ""}
        </Select>
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
    </GridToolbarContainer>
  );
}










const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface roleType {
  role: string;
  user_id: string;
  type: string;
  use_yn: string;
}

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  birth: string;
  gender: string;
  jumin: string;
  bank: string;
  bank_num: string;
  phone: string;
  startDate: string;
  roles: roleType[];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const MemberToManagerTable = () => {

  const [auths, setAuths] = useState([]);

  const store = useSelector((state:any)=> state)

  // console.log('store',store)

  const authCodeList = useSelector((state:any)=> state.code.auth.data)
  const getCodeNm = (role:string) =>{
    
    if(role === "ADMIN"){
      return "관리자"
    }
    else if(authCodeList){
      // console.log('authCodeList',authCodeList,role)

      // authCodeList.find((authCode:any)=> authCode.code === role)

      const find_role = authCodeList.find((authCode:any)=> authCode.code === role)

      // console.log('find_role',find_role)

      if(find_role){
        return find_role.code_nm.toString()
      }else{
        return ""
      }
    }
  }

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    
  };

  const columns: GridColDef[] = [
    { field: "id", headerName: "id", headerAlign: "center", width: 90,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>ID</Box>
      )
    },
    {
      field: "email", headerName: "이메일", headerAlign: "center", headerClassName: "header-style", width: 200,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이메일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "name", headerName: "이름", headerAlign: "center", width: 100,
        renderHeader: (params: any) => (
          <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이름</Box>
        ),
        renderCell: (params:any) => (
          <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
        ),
      },
    { field: "birth", headerName: "생년월일", headerAlign: "center", width: 130, type: "date",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>생년월일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "gender", headerName: "성별", headerAlign: "center", width: 110,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>성별</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "phone", headerName: "전화번호", headerAlign: "center", width: 150,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validatephone(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>전화번호</Box>
      ),
    },
    { field: "startDate", headerName: "가입일", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>가입일</Box>
      ),
    },
    { field: "roles", headerName: "권한", headerAlign: "center", width: 300,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>권한</Box>
      ),
      valueGetter: (params: any) => {
        // console.log('valueGetter' , params.value)
        const work_role = params.value.filter((role:any) => role.role === 'ADMIN' || role.use_yn === "sample_confirm");
        // console.log('work_role',work_role)
        // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');

        // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
        const role_code_nm = params.value.map((wr:any) => getCodeNm(wr.role))
        // console.log('role_code_nm',role_code_nm)
  
        return role_code_nm.toString();
      },
      valueSetter: (params: any) => {
        console.log('valueSetter' , params.value)
        const work_role = params.value.filter((role:any) => role.role === 'ADMIN');
        console.log('work_role',work_role)
        return work_role.toString()
        // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');
        // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
        // console.log('role_code_nm',role_code_nm)
  
        // return role_code_nm.toString();
      },
      valueParser: (params: any) => {
        console.log('valueParser' , params)
        // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');
        // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
        // console.log('role_code_nm',role_code_nm)
  
        // return role_code_nm.toString();
      },
      // renderCell: (params:any) => (
      //     <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      // )
    },
  ];
  
  

  // console.log('get Code Nm' , getCodeNm('NKI'))

  const [page, setPage] = useState(1);

  const [roleParam, setRoleParam] = useState('모두');
  const [managerParam, setManagerParam] = useState('연결안됨');

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    email: "",
    name: "",
    birth: "",
    gender: "",
    jumin: "",
    bank: "",
    bank_num: "",
    phone: "",
    startDate: "",
    roles: [{role:"",user_id:"",type:"",use_yn:""}],
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getMemberList = async (managerParam:any) => {
    if(managerParam == undefined){
      managerParam = '연결안됨'
    }
    var result = await api.get("/dialogWorkerToManagerList",{params:{email:email,page:page,managerParam:managerParam}});
    console.log("result.data", result.data);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        email: data.email,
        name: data.name,
        birth: data.birth,
        gender: data.gender,
        jumin: data.jumin,
        bank: data.bank,
        bank_num: data.bank_num,
        phone: data.phone,
        startDate: data.startDate,
        roles: data.roles,
      };
    });

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    // console.log("data", result.data.datas);
  };

  const [managers, setManagers] = useState([]);

  const [selectedManager, setSelectedManager] = useState("");

  const getManagerList = async () => {

    var result = await api.get("/managerList",{params:{email:email}});
    console.log("result.data", result.data);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        email: data.email,
        name: data.name
      };
    });

    setManagers(datas);
  };

  useEffect(() => {
    getAuths();
    getManagerList();
    getMemberList(managerParam);
  }, [managerParam,page]);

  const goDetail = (data: any) => {
    // console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    // console.log("CustomFooter pagination", pagination);
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const [selectedWorkers, setSelectedWorkers] = React.useState([]);

  const handleSelectionModelChange = (ids:any) => {
    // console.log('handleSelectionModelChange    id ??? ' , ids)
    setSelectedWorkers(ids);
  };

  const workerToManger = async () => {

    if(!selectedManager){
      alert("중간관리자를 선택해주세요.")
      return ;
    }

    if(selectedWorkers.length < 1){
      alert("중간관리자에게 배분할 인력이 선택되지 않았습니다.")
      return ;
    }

    await api.post("/updateDialogWorkerToManager",{"email":email,"manager": selectedManager,"workers":selectedWorkers})
    .then((res:any) => {alert("중간관리자 연결이 완료되었습니다. "); getMemberList(managerParam); })
    .catch((e) => {if(e.response.status == 400 || e.response.status == 500) alert("중간관리자 연결 오류.")})
    
  }

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"}
        // ".header-style":{
        //   backgroundColor: "#95b1d1",
        //   fontWeight: 600,
        //   color: "#fff"
        // }
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>중간관리자 인력 배분</h3></Box>
        <Box sx={{ width: "100%", display:"flex", marginLeft:"8px" }}>
          {managerParam == "연결안됨" ?
          <Box>
            <Select
              labelId="demo-simple-select-label"
              id="role" 
              name="role"
              value={selectedManager}
              label="권한"
              sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
              onChange={(e)=> {console.log('메니저 선택',e.target.value); setSelectedManager(e.target.value);}}
            >
              <MenuItem dense value={""}></MenuItem>
              {managers.length !== 0 ? (
                managers.map((manager: any, index:number) => {
                  return (
                    <MenuItem key={manager.email} dense value={manager.email}>{manager.name}</MenuItem>
                  );
                })
              ) : ""}
            </Select>
            <Button variant="contained" onClick={()=>workerToManger()} >중간관리자 연결</Button>
          </Box>
          :""}
        </Box>
        <Box sx={{ height: "600px", width: "100%" }}>
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            selectionModel={selectedWorkers} // For controlled selection
            pageSize={100}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                managerParam: managerParam,
                setManagerParam: setManagerParam,
                auths: auths,
                managers: managers
              },
            }}
            getRowId={(row) => row.email}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            // sx={{"&.MuiDataGrid-cell--textLeft": {justifyContent : "center"}}}
          />
        </Box>
      </ThemeProvider>
      {/* <MemberDetailDiaglog setDialogOpen={setDialogOpen} rowDetail={rowDetail} setRowDetail={setRowDetail} getMemberList={getMemberList} />
      {dialogOpen ? <MemberDetailDiaglog memberInfo={rowDetail} /> : <></>} */}
      {dialogOpen == true ? (
        <MemberDetailDiaglog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getMemberList={getMemberList}
          />
          ) : ""}
        </Box>
      );
    };
export default MemberToManagerTable;
